const resource = resolve =>require(['@/components/admin/Resource.vue'], resolve)
// const exercisesBank = resolve =>require(['@/components/admin/school/School.vue'], resolve)
import exercisesBank from './exercisesBank.js'


export default {
    path: '/homePage/resource',
    name: '资源管理',
    component: resource,
    meta: {
      title: "资源管理",
      keepAlive : true,
      breadList: [
        {
        title: '资源管理',
        path: '/homePage/resource'
      }]
    }
}




// WEBPACK FOOTER //
// ./src/router/admin/resource.js